// import React, { useState, useEffect } from "react";
// import { Layout, Menu, Card, Typography } from "antd";
// import { motion, AnimatePresence } from "framer-motion";
// import pose from "../../Assets/variation/pose.jpg";
// import axios from "axios";
// import { API_BASE_URL } from "../../Config";
// import AdvertisementCard from "../AdvertisementCard";

// const { Sider, Content } = Layout;
// const { Title, Paragraph } = Typography;

// const WarmUp = () => {
//   const [selectedKey, setSelectedKey] = useState("home");
//   const [allYogaPages, setAllYogaPages] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchAllYoga = async () => {
//       try {
//         const res = await axios.get(`${API_BASE_URL}/allpages?page=warmup`);
//         const json = await res.data;
//         setAllYogaPages(json?.data || []);
//       } catch (error) {
//         console.error("API Fetch Error", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAllYoga();
//   }, []);

//   const getDynamicPageContent = (key) => {
//     if (key === "home") {
//       const home = allYogaPages.find((p) => p.yogaType === "Yoga Main Page");
//       if (home) return home.content;

//       return `
//        <h1 style={{ textAlign: "center",fontFamily: "manrope"  }}>
//           Preparatory training
//         </h1>
//         <Paragraph
//           style={{
//             maxWidth: 700,
//             margin: "10px auto",
//             lineHeight: 1.7,
//             fontFamily: "manrope"
//           }}
//         >
//           This is a full-body dynamic warm-up routine designed to increase blood
//           flow, improve joint mobility, and prepare the muscles and nervous
//           system for physical activity. It systematically moves through all the
//           major joints and muscle groups of the body, from the neck down to the
//           ankles, culminating in a coordination/cognitive exercise (Super Brain
//           Yoga).
//         </Paragraph>
//         <Paragraph
//           style={{
//             maxWidth: 700,
//             margin: "10px auto",
//             lineHeight: 1.7,
//           }}
//         >
//           <b>
//             Preparatory training is applicable to everything from yoga, martial
//             arts, dance, and more.
//           </b>
//         </Paragraph>
//         <Paragraph
//           style={{
//             maxWidth: 700,
//             margin: "10px auto",
//             lineHeight: 1.7,
//           }}
//         >
//           <b>
//             Everyone who practices yoga must definitely read and practice
//             Alternate Yoga.
//           </b>
//         </Paragraph>
//         <h2 style={{ color: "#0c5c78" }}>Benefits:</h2>
//         <ol style={{ lineHeight: 1.8 }}>
//           <li>
//             <b>Injury Prevention:</b>Prepares muscles, tendons, and ligaments
//             for strain, reducing the risk of pulls and tears.
//           </li>
//           <li>
//             <b>Improved Performance: </b>Increases heart rate and blood flow,
//             delivering more oxygen to muscles, which can lead to better
//             strength, speed, and endurance.
//           </li>
//           <li>
//             <b>Enhanced Flexibility & Range of Motion: </b>Gently takes joints
//             through their full range, improving flexibility over time.
//           </li>
//           <li>
//             <b>Better Mind-Muscle Connection: </b>Increases body awareness and
//             coordination.
//           </li>
//           <li>
//             <b>Mental Preparation: </b>Helps shift focus to the upcoming
//             physical activity.
//           </li>
//         </ol>
//         <h2 style={{ color: "#0c5c78" }}>Precautions:</h2>
//         <ol style={{ lineHeight: 1.8 }}>
//           <li>
//             <b>Move Gently: </b>Do not force any movement. Warm-ups should not
//             be painful.
//           </li>
//           <li>
//             <b>Avoid Jerking: </b>Use smooth, controlled motions, especially
//             with the neck and back.
//           </li>
//           <li>
//             <b>Listen to Your Body: </b>If you feel sharp pain, stop
//             immediately.
//           </li>
//           <li>
//             <b>Breathe: </b>Do not hold your breath. Breathe naturally
//             throughout the movements.
//           </li>
//           <li>
//             <b>Existing Injuries: </b>Be extra cautious around any previously
//             injured areas.
//           </li>
//         </ol>
//         <p>
//           <b>Note:</b>This sequence of doing the preparatory exercises, then
//           Surya Namaskar, and then moving on to the asana is very correct and
//           effective.
//         </p>
//       `;
//     }

//     const page = allYogaPages.find((p) => p._id === key);
//     return page?.content || "<p>No content found.</p>";
//   };

//   const grouped = {};

//   allYogaPages.forEach((item) => {
//     const type = item.warmupType;

//     if (!grouped[type]) grouped[type] = [];
//     grouped[type].push(item);
//   });

//   const menuItems = [
//     ...Object.keys(grouped)
//       .map((type) => {
//         const items = grouped[type];

//         if (type === "others") {
//           return items.map((item) => ({
//             key: item._id,
//             label: item.yogaType,
//           }));
//         }

//         if (items.length > 1) {
//           return {
//             key: type,
//             label: type.charAt(0).toUpperCase() + type.slice(1),
//             children: items.map((item) => ({
//               key: item._id,
//               label: item.yogaType, // ✅ FIXED
//             })),
//           };
//         }

//         return {
//           key: type,
//           label: type.charAt(0).toUpperCase() + type.slice(1),
//           children: [
//             {
//               key: items[0]._id,
//               label: items[0].yogaType, // ✅ FIXED
//             },
//           ],
//         };
//       })
//       .flat(),

//     {
//       key: "home",
//       label: "Back to Mainpage",
//     },
//   ];

//   const selectedContent = (
//     <div
//       className="page-content"
//       dangerouslySetInnerHTML={{ __html: getDynamicPageContent(selectedKey) }}
//     />
//   );

//   return (
//     <motion.div
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       transition={{ duration: 1 }}
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         padding: "30px 10px",
//         minHeight: "100vh",
//         background: "#f0f2f5",
//       }}
//     >
//       <Layout
//         className="responsive"
//         style={{
//           width: "90%",
//           maxWidth: "1200px",
//           background: "#fff",
//           borderRadius: "16px",
//           boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//           display: "flex",
//           overflow: "hidden",
//         }}
//       >
//         <Sider
//           className="sub_slider"
//           width={250}
//           style={{
//             height: "900px",
//             backgroundImage: `url(${pose})`,
//             backgroundSize: "cover",
//             backgroundPosition: "center",
//             position: "relative",
//           }}
//         >
//           <div
//             style={{
//               position: "absolute",
//               inset: 0,
//               background: "rgba(0,0,0,0.6)",
//             }}
//           />

//           <div
//             style={{
//               position: "relative",
//               zIndex: 2,
//               padding: "16px",
//               fontWeight: "bold",
//               textAlign: "center",
//               color: "#fff",
//             }}
//           >
//             Breathe Techniques
//           </div>

//           <Menu
//             theme="white"
//             mode="inline"
//             style={{
//               background: "transparent",
//               color: "#ffffffA2",
//               fontSize: "1.1rem",
//               position: "relative",
//               zIndex: 2,
//               fontWeight: 500,
//               textAlign: "center",
//             }}
//             itemStyle={{ color: "#fff" }}
//             onClick={(e) => setSelectedKey(e.key)}
//             selectedKeys={[selectedKey]}
//             items={menuItems}
//           />
//         </Sider>

//         <Content className="content_responsive" style={{ padding: "30px" }}>
//           {loading ? (
//             <h2>Loading...</h2>
//           ) : (
//             <AnimatePresence mode="wait">
//               <motion.div
//                 key={selectedKey}
//                 initial={{ opacity: 0, y: 30 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 exit={{ opacity: 0, y: -20 }}
//                 transition={{ duration: 0.4 }}
//               >
//                 <Card
//                   className="inner_card"
//                   style={{ borderRadius: "12px", padding: "24px" }}
//                 >
//                   {selectedContent}
//                 </Card>
//               </motion.div>
//             </AnimatePresence>
//           )}
//         </Content>
//       </Layout>
//       <AdvertisementCard />
//     </motion.div>
//   );
// };

// export default WarmUp;

import React, { useState, useEffect } from "react";
import { Layout, Menu, Card } from "antd";
import { motion, AnimatePresence } from "framer-motion";
import pose from "../../Assets/variation/pose.jpg";
import axios from "axios";
import { API_BASE_URL } from "../../Config";
import AdvertisementCard from "../AdvertisementCard";

const { Sider, Content } = Layout;

// Plain HTML fallback string (no JSX syntax)
const HOME_FALLBACK_HTML = `
  <h1 style="text-align:center; font-family:manrope;">Preparatory training</h1>
  <p style="max-width:700px; margin:10px auto; line-height:1.7; font-family:manrope;">
    This is a full-body dynamic warm-up routine designed to increase blood
    flow, improve joint mobility, and prepare the muscles and nervous
    system for physical activity. It systematically moves through all the
    major joints and muscle groups of the body, from the neck down to the
    ankles, culminating in a coordination/cognitive exercise (Super Brain Yoga).
  </p>
  <p style="max-width:700px; margin:10px auto; line-height:1.7;">
    <b>Preparatory training is applicable to everything from yoga, martial
    arts, dance, and more.</b>
  </p>
  <p style="max-width:700px; margin:10px auto; line-height:1.7;">
    <b>Everyone who practices yoga must definitely read and practice Alternate Yoga.</b>
  </p>
  <h2 style="color:#0c5c78;">Benefits:</h2>
  <ol style="line-height:1.8;">
    <li><b>Injury Prevention:</b> Prepares muscles, tendons, and ligaments for strain, reducing the risk of pulls and tears.</li>
    <li><b>Improved Performance:</b> Increases heart rate and blood flow, delivering more oxygen to muscles, which can lead to better strength, speed, and endurance.</li>
    <li><b>Enhanced Flexibility &amp; Range of Motion:</b> Gently takes joints through their full range, improving flexibility over time.</li>
    <li><b>Better Mind-Muscle Connection:</b> Increases body awareness and coordination.</li>
    <li><b>Mental Preparation:</b> Helps shift focus to the upcoming physical activity.</li>
  </ol>
  <h2 style="color:#0c5c78;">Precautions:</h2>
  <ol style="line-height:1.8;">
    <li><b>Move Gently:</b> Do not force any movement. Warm-ups should not be painful.</li>
    <li><b>Avoid Jerking:</b> Use smooth, controlled motions, especially with the neck and back.</li>
    <li><b>Listen to Your Body:</b> If you feel sharp pain, stop immediately.</li>
    <li><b>Breathe:</b> Do not hold your breath. Breathe naturally throughout the movements.</li>
    <li><b>Existing Injuries:</b> Be extra cautious around any previously injured areas.</li>
  </ol>
  <p>
    <b>Note:</b> This sequence of doing the preparatory exercises, then Surya Namaskar,
    and then moving on to the asana is very correct and effective.
  </p>
`;

const WarmUp = () => {
  const [selectedKey, setSelectedKey] = useState("home");
  const [allYogaPages, setAllYogaPages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllYoga = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/allpages?page=warmup`);
        setAllYogaPages(res.data?.data || []);
      } catch (error) {
        console.error("API Fetch Error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllYoga();
  }, []);

  const getDynamicPageContent = (key) => {
    if (key === "home") {
      const home = allYogaPages.find((p) => p.yogaType === "Yoga Main Page");
      // Use CMS content if available, otherwise fall back to plain HTML string
      return home ? home.content : HOME_FALLBACK_HTML;
    }

    const page = allYogaPages.find((p) => p._id === key);
    return page?.content || "<p>No content found.</p>";
  };

  // Group pages by warmupType
  const grouped = {};
  allYogaPages.forEach((item) => {
    const type = item.warmupType;
    if (!grouped[type]) grouped[type] = [];
    grouped[type].push(item);
  });

  const menuItems = [
    ...Object.keys(grouped)
      .map((type) => {
        const items = grouped[type];

        // Flat items for "others" group
        if (type === "others") {
          return items.map((item) => ({
            key: item._id,
            label: item.yogaType,
          }));
        }

        // Single item: render as a flat menu item (no unnecessary submenu)
        if (items.length === 1) {
          return {
            key: items[0]._id,
            label: items[0].yogaType,
          };
        }

        // Multiple items: render as a submenu group
        return {
          key: type,
          label: type.charAt(0).toUpperCase() + type.slice(1),
          children: items.map((item) => ({
            key: item._id,
            label: item.yogaType,
          })),
        };
      })
      .flat(),

    {
      key: "home",
      label: "Back to Mainpage",
    },
  ];

  const selectedContent = (
    <div
      className="page-content"
      dangerouslySetInnerHTML={{ __html: getDynamicPageContent(selectedKey) }}
    />
  );

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "30px 10px",
        minHeight: "100vh",
        background: "#f0f2f5",
      }}
    >
      <Layout
        className="responsive"
        style={{
          width: "90%",
          maxWidth: "1200px",
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          display: "flex",
          overflow: "hidden",
        }}
      >
        <Sider
          className="sub_slider"
          width={250}
          style={{
            height: "900px",
            backgroundImage: `url(${pose})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(0,0,0,0.6)",
            }}
          />

          <div
            style={{
              position: "relative",
              zIndex: 2,
              padding: "16px",
              fontWeight: "bold",
              textAlign: "center",
              color: "#fff",
            }}
          >
            Techniques
          </div>

          {/* FIX: theme="dark" is valid; "white" is not */}
          {/* FIX: removed invalid itemStyle prop; use CSS to target .ant-menu-item */}
          <Menu
            theme="white"
            mode="inline"
            style={{
              background: "transparent",
              fontSize: "1.1rem",
              position: "relative",
              zIndex: 2,
              fontWeight: 400,
              textAlign: "center",
              color: "#fff",
            }}
            onClick={(e) => setSelectedKey(e.key)}
            selectedKeys={[selectedKey]}
            items={menuItems}
          />
        </Sider>

        <Content className="content_responsive" style={{ padding: "30px" }}>
          {loading ? (
            <h2>Loading...</h2>
          ) : (
            <AnimatePresence mode="wait">
              <motion.div
                key={selectedKey}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
              >
                <Card
                  className="inner_card"
                  style={{ borderRadius: "12px", padding: "24px" }}
                >
                  {selectedContent}
                </Card>
              </motion.div>
            </AnimatePresence>
          )}
        </Content>
      </Layout>
      <AdvertisementCard />
    </motion.div>
  );
};

export default WarmUp;
